import { PrispekPolicies } from './Prispek.Policies';

export const SpektraPolicies = PrispekPolicies.concat([
    {
        Name: 'Accounting Policy_Signed',
        Reference:
            'https://drive.google.com/file/d/1CznMXA_xsARCVcc6Kwu2uWKKlZbe66Rn/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Financial Soundness',
        Reference:
            'https://drive.google.com/file/d/1WVuxS_DZVgeGcXnYk-tVA1JbEWNMLKYz/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Compliance Declaration',
        Reference:
            'https://drive.google.com/file/d/1nz99och9c6YNU0fHxYvwF1AgVSGy4ASb/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Advertising Checklist & Sign-Off',
        Reference:
            'https://drive.google.com/file/d/1N5UkigfrIeYaggp3gkyGAgo0FrjQRGPm/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Advertising',
        Reference:
            'https://drive.google.com/file/d/1Rq4cnqY5LZ6rJ9TMDQjN4lggdaRg-ayh/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Complaint Procedure Client Communication',
        Reference:
            'https://drive.google.com/file/d/1JfuEq0k5lYC42JaQYcoQzaKTf80NpZEh/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Complaints Policy',
        Reference:
            'https://drive.google.com/file/d/1Tvz7wMbM5GFDHqckTxvInBAX0YFTasKG/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Complaints Management Process',
        Reference:
            'https://drive.google.com/file/d/1JlF8_nlD95E_ApbKZE0_Z2WFIIS52YlX/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Termination of Agreement or Business',
        Reference:
            'https://drive.google.com/file/d/12bhEU5fLa_BzNPz1Vl8Fzq_xuXprYCQx/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Written Termination of Mandate',
        Reference:
            'https://drive.google.com/file/d/1-dCE7njyfFdA56ZytaZyUO70gRHjuF6-/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Competence Evaluation Review Form_Christo',
        Reference:
            'https://drive.google.com/file/d/1H0i-gphR3zQRt4s-R_cXeKCGERKxHs9X/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Competence Requirements',
        Reference:
            'https://drive.google.com/file/d/1b70kC5VHE940Z_ZHD9ZiBBLTpjWipMA5/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Compliance Declaration - Execution of Sales_Christo',
        Reference:
            'https://drive.google.com/file/d/16kcd0mAjWBgkiSg2YQkfDBOIQSf-qOi0/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Compliance Declaration - Support Staff_Christo',
        Reference:
            'https://drive.google.com/file/d/1hU8Kr4W_3-hJ0no_ZZpNGA9XgxvxhLRh/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Department',
        Reference:
            'https://drive.google.com/file/d/1WlP4-lIASUBtptSUrLtglnshN4uW38px/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'FIC',
        Reference:
            'https://drive.google.com/file/d/1UVHUp7j7PtpDVH1MeAvLQoz1WyR-p6cm/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Compliance Declaration - Honesty Integrity',
        Reference:
            'https://drive.google.com/file/d/1UVHUp7j7PtpDVH1MeAvLQoz1WyR-p6cm/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'SPB Honesty Integrity  Good Standing',
        Reference:
            'https://drive.google.com/file/d/1dMZHXBXjDlY7sCbttqAesVf88LB4zbD5/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Remuneration',
        Reference:
            'https://drive.google.com/file/d/1I4aKGotvsSLdCU30p0p_lTHACX7swfU7/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Representative',
        Reference:
            'https://drive.google.com/file/d/1OfvAwSPQ6ERBS_5mWMo4ZPnj8Cg_c6HT/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Risk management',
        Reference:
            'https://drive.google.com/file/d/1N7p9-o6RUcAnc0H-atJmZW0GaUE-MRYx/view?usp=sharing',
        Variant: 'item'
    },
    {
        Name: 'Strategic Business Plan',
        Reference:
            'https://drive.google.com/file/d/1N7p9-o6RUcAnc0H-atJmZW0GaUE-MRYx/view?usp=sharing',
        Variant: 'item'
    }
]);
